// Regras puras da tela de Treinos (admin): sem React, sem rede.
import type { CognitiveDomain, MindTrainingItem, PickableGame } from '../../services/admin';
import { DOMAINS, domainLabel } from './academy';

export const fromTrainingItems = (items: MindTrainingItem[]): PickableGame[] =>
  [...items]
    .sort((a, b) => a.position - b.position)
    .map((i) => ({
      kind: i.kind,
      id: i.id,
      titulo: i.titulo,
      subtitulo: null,
      tipoId: i.tipoId,
      edicaoId: i.edicaoId,
      edicaoNome: i.edicaoNome,
      cognitiveDomain: i.domain,
      academyPoints: i.points,
    }));

/** Áreas sem nenhum jogo na seleção, na ordem de DOMAINS. */
export const missingDomains = (games: PickableGame[]): CognitiveDomain[] => {
  const covered = new Set(games.map((g) => g.cognitiveDomain));
  return DOMAINS.map((d) => d.value).filter((d) => !covered.has(d));
};

export const missingDomainsWarning = (missing: CognitiveDomain[]): string | null =>
  missing.length === 0
    ? null
    : `Este treino não tem jogo de ${missing.map(domainLabel).join(', ')}.`;
